import req from "@/assets/js/axios"
const transformRequest = {
  transformRequest: [function (data) {
    return data;
  }]
}
// 用户相关接口
export default {
  /** 获取账号信息*/
  getUserInfo: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/starrycastle-security/getUserInfo', params);
  },
  /** 条件查询字典*/
  getDictionaries: (params, loading) => {
    let obj = loading ? transformRequest : null;
    return req.apiAxios('POST', '/host/dictionary/DictionaryController/getDictionaries', params, false, obj);
  },
  /** 获取数据字典*/
  getDictionaryCode: (params) => {
    return req.apiAxios('POST', '/host/dictionary/DictionaryController/getDictionaryCode', params);
  },
  /** 上传文件*/
  uploadFile: (params) => {
    return req.apiAxios('POST', '/host/aliyun/oss/OSSController/starrycastle-security/uploadFile', params);
  },
  /** 获取图形验证码*/
  verifyCode: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/verifyCode', params);
  },
  /**loginKey获取用户信息*/
  getUserByLoginKey: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/getUserByLoginKey', params);
  },
  /**更新用户信息*/
  updateUser: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/starrycastle-security/updateUser', params);
  },
  /** 修改密码 */
  modifyPassword: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/modifyPassword', params);
  },
  /** 发送验证码*/
  sendMobileCode: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/sendMobileCode', params);
  },
  /** 验证原手机*/
  verifyOldMobile: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/starrycastle-security/verifyOldMobile', params);
  },
  /** 修改手机*/
  modifyMobile: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/starrycastle-security/modifyMobile', params);
  },
  /** 微信绑定*/
  bindOpenUserWeChat: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/bindOpenUserWeChat', params);
  },
  /** 解除绑定第三方账号*/
  unbindOpenUser: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/unbindOpenUser', params);
  },
  /** 发送绑定邮箱*/
  bindEmail: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/starrycastle-security/bindEmail', params);
  },
  /** 验证邮箱*/
  activateEmail: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/starrycastle-security/activateEmail', params);
  },
  /** 手机号注册*/
  register: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/register', params)
  },
  /** 验证码登录*/
  loginByMobileCode: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/loginByMobileCode', params)
  },
  /** 密码登录*/
  loginByPassword: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/loginByPassword', params)
  },
  /** 退出登录 */
  exitLogin: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/exitLogin', params)
  },
  /** 获取反馈建议 */
  getFeedbacks: (params) => {
    return req.apiAxios('POST', '/host/feedback/FeedbackController/getFeedbacks', params)
  },
  /** 条件查询活动(前台） */
  getActivities: (params) => {
    return req.apiAxios('POST', '/activity/ActivityController/getActivities', params)
  },
  /** 验证手机号 */
  checkMobile: (params) => {
    return req.apiAxios('POST', '/host/user/UserController/checkMobile', params)
  },
  /** 添加用户反馈 */
  createFeedback: (params) => {
    return req.apiAxios('POST', '/host/feedback/FeedbackController/createFeedback', params)
  },
  // 添加用户收藏
  createFrontCollection: (params, loading) => {
    let obj = loading ? transformRequest : null;
    return req.apiAxios("POST", '/host/collection/CollectionController/starry-security/createFrontCollection', params, false, obj)
  },
  // 取消用户收藏
  deleteFrontCollection: (params, loading) => {
    let obj = loading ? transformRequest : null;
    return req.apiAxios("POST", '/host/collection/CollectionController/starry-security/deleteFrontCollection', params, false, obj)
  },
  // 查询用户收藏
  getFrontCollections: (params) => {
    return req.apiAxios("POST", '/host/collection/CollectionController/starry-security/getFrontCollections', params)
  },
  // 查询用户收藏-不需要登录
  getCollections: (params) => {
    return req.apiAxios("POST", '/host/collection/CollectionController/getFrontCollections', params)
  },
  // 条件查询资讯（前台）
  getNews: (params) => {
    return req.apiAxios("POST", '/host/news/NewsController/getNews', params)
  },
  // 获取作品浏览记录
  getMessages: (params) => {
    return req.apiAxios("POST", '/host/message/MessageController/getMessages', params)
  },
  // 创建视频上传
  createUploadVideo: (params) => {
    return req.apiAxios("POST", '/host/aliyun/vod/VODController/createUploadVideo', params)
  },

}
